import { render, staticRenderFns } from "./header-variant-1.vue?vue&type=template&id=436f8162&"
import script from "./header-variant-1.vue?vue&type=script&lang=ts&"
export * from "./header-variant-1.vue?vue&type=script&lang=ts&"
import style0 from "./header-variant-1.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "../../../assets/scss/grid.scss?vue&type=style&index=1&lang=scss&module=styleGrid&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["styleGrid"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports